// A turn's pending moves (not yet sent: they can still be undone), kept in this browser so reloading the page doesn't
// lose them. One entry per game and player; the engine picks it up only if the game hasn't moved on (see GameEngine's
// options.keep). Nothing here goes to the server.
const keyOf = (gameId, viewer) => `tta-turn:${gameId}:${viewer}`;

export const KeptTurn = (gameId, viewer) => ({
    load: () => {
        try { return JSON.parse(window.localStorage.getItem(keyOf(gameId, viewer)) ?? 'null'); } catch { return null; }
    },
    save: (kept) => {
        try {
            if (kept)
            {
                window.localStorage.setItem(keyOf(gameId, viewer), JSON.stringify(kept));
            } else {
                window.localStorage.removeItem(keyOf(gameId, viewer));
            }
        } catch { /* (then not kept: as before) */ }
    },
});
